var supportDescriptors = require('core-js/internals/descriptors.js');
var defineProperty = require('core-js/internals/object-define-property.js').f;
var NAME = 'replaceChildren';

if (supportDescriptors) {
  // Objects types that implement ParentNode interface
  var protos = [Document.prototype, DocumentFragment.prototype, Element.prototype, SVGElement.prototype];
  for (var i = 0; i < protos.length; i++) {
    var proto = protos[i];

    if (Object.prototype.hasOwnProperty.call(proto, NAME)) {
      continue;
    }

    defineProperty(proto, NAME, {
      configurable: true,
      value: function () {
        this.textContent = ''; // remove children (don't use innerHTML because the is an issue with IE, see https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent#Description)

        // Append new children
        // See also https://developer.mozilla.org/en-US/docs/Web/API/Element/append
        for (var i = 0; i < arguments.length; i++) {
          var nodeOrString = arguments[i];
          this.appendChild(
            typeof nodeOrString === 'string' || nodeOrString instanceof String
              ? this.ownerDocument.createTextNode(nodeOrString)
              : nodeOrString
          );
        }
      },
    });
  }
}
